import styled, { css } from 'styled-components';
import { ifProp, palette, theme } from 'styled-tools';

import { Button as _Button, fontSize, FontSizes, FontWeights, minWidth, Text } from '@calm-web/design-system';

export const Wrapper = styled.section<{
	isFullHeight?: boolean;
}>`
	padding-bottom: 60px;
	display: flex;
	flex-direction: column;
	padding-bottom: 0;
	background-color: ${palette('gray0')};
	${ifProp(
		'isFullHeight',
		css`
			min-height: 100svh;
		`,
	)}

	${minWidth('desktop')} {
		padding-bottom: 140px;
	}
`;
export const AppSection = styled.div`
	align-items: center;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	margin: 0 auto;
	max-width: 1440px;
	padding: 0 20px;
	text-align: center;

	${minWidth('desktop')} {
		flex-direction: row;
		padding: 0 136px;
	}
	transition: ${theme('animation.transition')};
`;

export const StickyCopy = styled.div`
	margin-bottom: 40px;

	${minWidth('desktop')} {
		align-self: flex-start;
		margin-bottom: 0;
		position: sticky;
		top: 240px;
	}
`;

export const Heading = styled(Text).attrs({
	el: 'h1',
	color: 'blue7',
	noMargin: true,
})`
	&&& {
		${fontSize(FontSizes['2xl'])}
		line-height: 150%;
		margin: 0 auto 8px;
		max-width: 250px;

		${minWidth('mobileLarge')} {
			max-width: none;
		}

		${minWidth('desktop')} {
			${fontSize(FontSizes['4xl'])}
		}
	}
`;

export const Body = styled(Text).attrs({
	el: 'p',
	noMargin: true,
	color: 'blackAlpha60',
	weight: FontWeights.Medium,
	size: FontSizes.lg,
})`
	&&& {
		margin-bottom: 36px;
	}
`;

export const ImageContainer = styled.div`
	background-color: ${palette('gray0')};
	height: 360px;
	margin-bottom: 32px;
	position: relative;
	z-index: 0;

	${minWidth('desktop')} {
		height: 480px;
		margin-bottom: 40px;
	}

	&:after {
		background: linear-gradient(
			180deg,
			rgba(247, 247, 247, 0) 0%,
			rgba(247, 247, 247, 0.0885417) 8.85%,
			#f7f7f7 100%
		);
		height: 40px;
		bottom: 0;
		content: '';
		left: 0;
		position: absolute;
		right: 0;

		${minWidth('desktop')} {
			background: linear-gradient(
				180deg,
				rgba(247, 247, 247, 0) 0%,
				rgba(247, 247, 247, 0.0885417) 8.85%,
				#f7f7f7 100%
			);

			height: 100px;
		}
	}
`;

export const ButtonContainer = styled.div`
	align-items: center;
	display: flex;
	flex-direction: column;
	justify-content: center;
	gap: 16px;

	${minWidth('desktop')} {
		flex-direction: row;
		gap: 12px;
	}
`;

export const Button = styled(_Button)`
	max-width: 335px;
`;
